<template>
  <div>
    <div class="button-div">
      <Button @click="save()" type="primary" :loading="saveLoading" class="button-right-left">保存</Button>
      <Button @click="back()" class="button-right">返回</Button>
    </div>
    <div class="form-area">
      <Form style="width: 600px" :model="template" ref="templateForm" :rules="rules" :label-width="120"
            label-position="left">
        <FormItem label="套件名称" prop="suiteName">
          <Input class="input-width" v-model="template.suiteName"></Input>
        </FormItem>
        <FormItem label="套件编号" prop="suiteCode">
          <Input class="input-width" v-model="template.suiteCode"></Input>
        </FormItem>
        <FormItem label="套件版本" prop="suiteVersion">
          <Input class="input-width" v-model="template.suiteVersion"></Input>
        </FormItem>
        <FormItem label="模板类型" prop="suiteType">
          <Select v-model="template.suiteType">
            <Option :value="0">单表</Option>
            <Option :value="3">工作流表单</Option>
          </Select>
        </FormItem>
        <FormItem label="保存路径" v-show="template.id !== null">
          <Input class="input-width" v-model="template.suitePath" disabled></Input>
        </FormItem>
        <FormItem label="套件模版文件" prop="mFile">
          <Upload v-model="template.mFile" ref="upload" action="" :before-upload="handleUpload">
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
          </Upload>
          <div>
            <ul class="ivu-upload-list" v-if="template.mFile !== null">
              <li class="ivu-upload-list-file ivu-upload-list-file-finish">
                                <span><i class="ivu-icon ivu-icon-ios-document-outline"></i>
                                    {{fileName}}
                                </span>
              </li>
            </ul>
            <ul class="ivu-upload-list" v-if="template.mFile == null&&template.id !== null">
              <li class="ivu-upload-list-file ivu-upload-list-file-finish">
                                <span><i class="ivu-icon ivu-icon-ios-document-outline"></i>
                                    {{template.suiteCode}}-{{template.suiteVersion}}.zip
                                </span>
              </li>
            </ul>
          </div>
        </FormItem>
      </Form>
    </div>
  </div>

</template>

<script>
  import Util from '@/libs/util.js';

  export default {
    name: 'Template',
    data () {
      const validateUpload = (rule, value, callback) => {
        if (this.template.id !== null && this.template.mFile === null) {
          callback();
        } else {
          if (this.template.mFile === null) {
            callback(new Error('请上传模板文件'));
          } else {
            let name = this.template.mFile.name;
            let index = name.lastIndexOf('.');
            let type = name.substring(index, name.length);
            if (type !== '.zip') {
              callback(new Error('文件格式只能为zip'));
            } else {
              callback();
            }
          }
        }
      };
      return {
        saveLoading:false,
        fileName: null,
        template: {
          id: null,
          suiteName: '',
          suiteCode: '',
          suiteVersion: '',
          suitePath: '',
          suiteType: 0,
          mFile: null,
        },
        rules: {
          suiteName: [
            {required: true, message: '请输入套件名称', trigger: 'blur'}
          ],
          suiteCode: [
            {required: true, message: '请输入套件编号', trigger: 'blur'}
          ],
          suiteVersion: [
            {required: true, message: '请输入套件版本', trigger: 'blur'}
          ],
          suiteType: [
            {required: true, message: '请选择模板类型', trigger: 'change', type: 'number'}
          ],
          mFile: [
            {required: true, validator: validateUpload, trigger: 'change'}
          ]
        }
      };
    },
    mounted () {
      if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
        this.id = this.$route.query.id;
        this.initForm();
      }
    },
    methods: {
      save () {
        let _this = this;
        this.$refs['templateForm'].validate((valid) => {
          if (valid) {
            if (_this.template.id === null) {
              _this.create();
            } else {
              _this.put();
            }
          }
        });
      },
      create () {
        let This = this;
        let param = new FormData();
        This.saveLoading=true;
        param.append('suiteName', This.template.suiteName);
        param.append('suiteCode', This.template.suiteCode);
        param.append('suiteVersion', This.template.suiteVersion);
        param.append('suitePath', This.template.suitePath);
        param.append('suiteType', This.template.suiteType);
        param.append('multipartFile', This.template.mFile);

        const [url, httpConfig] = [
          '/api/codeTemplateSuites',
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ]
        This.$http.post(url,param,httpConfig).then(function (response) {
          This.$Notice.success({
            title: '保存成功'
          });
          This.$router.push({
            name: 'defined-form-template-list'
          });

        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败！'
            });
            This.saveLoading=false;
            console.log(error);
          });
      },
      put () {

        let This = this;
        let param = new FormData();
        This.saveLoading=true;
        param.append('id', This.template.id);
        param.append('suiteName', This.template.suiteName);
        param.append('suiteCode', This.template.suiteCode);
        param.append('suiteVersion', This.template.suiteVersion);
        param.append('suitePath', This.template.suitePath);
        param.append('suiteType', This.template.suiteType);
        param.append('multipartFile', This.template.mFile);
        const [url, httpConfig] = [
          '/api/codeTemplateSuites/edit',
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ]
        This.$http.post(url,param,httpConfig).then(function (response) {
          This.$Notice.success({
            title: '保存成功'
          });
          This.$router.push({
            name: 'defined-form-template-list'
          });

        })
          .catch(function (error) {
            This.$Notice.error({
              title: '操作失败！'
            });
            This.saveLoading=false;
            console.log(error);
          });
      },
      handleUpload (file) {
        this.template.mFile = file;
        this.fileName = file.name;
        this.$refs['templateForm'].validate((valid) => {
        });
        return false;
      },
      initForm () {
        let This = this;
        This.$http.get('/api/codeTemplateSuites/' + This.id).then(function (response) {
          let tem = response.data;
          This.template.id = tem.id;
          This.template.suiteName = tem.suiteName;
          This.template.suiteCode = tem.suiteCode;
          This.template.suiteVersion = tem.suiteVersion;
          This.template.suitePath = tem.suitePath === null ? '' : tem.suitePath;
          This.template.suiteType = tem.suiteType;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      back () {
        let _this = this;
        let tagName = _this.$route.name;
        _this.$store.commit("removeTag", tagName);
        _this.$store.commit("closePage", tagName);
        _this.$router.push({
          name: "defined-form-template-list"
        });
      }
    }
  };
</script>

<style scoped>
  .button-div {
    display: flex;
    justify-content: flex-end;
  }

  .button-right-left {
    margin-right: 15px;
  }

  .button-right {
    margin-right: 55px;
  }

  .form-area {
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
</style>
